export const isTouchDevice = window.matchMedia('(hover: none)').matches;
